module.exports = __webpack_public_path__ + "static/img/作品11.60ca2c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品11.png
// module id = 1S0f
// module chunks = 1